import React from "react";
import { Drawer, Form, Row, Col, Button, Card, notification } from 'antd';
import _ from 'lodash';
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { API_URL, LAPI_URL } from "../../request";
import { connect } from "react-redux";
import Request from "../../request";
@Form.create()
class ChangeMultipleCounsellorAndDesk extends React.Component {
    state = {
        visible: true,
        counsellorsArr: []
    }



    componentDidMount() {
        this.loadCounsellors()
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    loadCounsellors = async () => {
        let { data } = await Request.loadAllCounsellors();
        data = data.reduce((temp, vv) => {
            temp.push({ id: vv._id, display: vv.name });
            return temp;
        }, [])
        this.setState({ counsellorsArr: data })
    }

    handleSubmit = (e) => {
        let { form, usersData } = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData)
            values.usersData = usersData;
            let response = await Request.changeMultipleCounsellorAndDesk(values);
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose();
        })
    }

    render() {
        let { visible, counsellorsArr } = this.state;
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;
        let inputTypes = {
            fields: [
                {
                    label: 'Choose Counsellor',
                    key: 'counsellorId',
                    type: 'select',
                    options: counsellorsArr,
                    showSearch: true,
                    required: true,
                    onChange: v => {
                        setFieldsValue({ counsellorId: v });
                    }
                },
                {
                    label: 'Choose Desk',
                    key: 'atLevel',
                    type: 'select',
                    required: true,
                    options: [{ id: 'Operation Manager Desk', display: 'Operation Manager Desk' }, { id: 'Front Desk', display: 'Counselling Desk' }, { id: 'Registration Desk', display: 'Registration Desk' }, { id: 'Application Desk', display: 'Application Desk' }, { id: 'Visa Desk', display: 'Visa Desk' }, { id: 'Claim Desk', display: 'Claim Desk' }],
                    onChange: v => {
                        setFieldsValue({ atLevel: v });
                    }
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Change Counsellor And Desk
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}>
                <Form onSubmit={this.handleSubmit}>
                    <GetAllFormFields apiurl={LAPI_URL}
                        inputSchema={inputTypes}
                        getFieldDecorator={getFieldDecorator} />
                    <Row style={{ marginTop: '20px' }}>
                        <Col span={8} />
                        <Col span={8}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ marginBottom: 10 }}
                                loading={this.props.loading}>
                                Save
                            </Button>
                        </Col>
                        <Col span={8} />
                    </Row>
                </Form>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChangeMultipleCounsellorAndDesk);